"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function AccountsfailedMultitoneOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__accountsfailed-multitone-outline__clip0_14553_7362)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.667,
    cy: 6.741,
    fill: "#CCE5FF",
    rx: 4,
    ry: 4.045
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M1.22 4.142l3.8 1.341v6.782l-3.8-1.417V4.142zM0 2.375v9.367l.093.034L6.05 13.99l.19.072V4.58l-.097-.033-5.95-2.11L0 2.376zM13.098 2.442L7.146 4.551l-.097.034v9.481l.19-.072.737-.274c.16-.063.299-.174.399-.319a.925.925 0 00.162-.495v-.164a.545.545 0 00-.038-.287.523.523 0 00-.178-.224h-.049V5.483l3.801-1.345V7.89c0 .168.064.329.179.448.114.118.27.185.43.185a.599.599 0 00.432-.185.645.645 0 00.179-.448V2.375l-.195.067zM6.76 1.308l2.183.733-2.163.764-2.353-.814 2.333-.683zM6.76 0L.715 1.759v.287l6.02 2.075h.094l5.586-1.966v-.282L6.825 0H6.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M12.562 16a3.424 3.424 0 01-2.182-.791 3.494 3.494 0 01.712-5.831c.46-.22.961-.335 1.47-.335a3.42 3.42 0 012.432 1.019 3.498 3.498 0 011.008 2.46c0 .922-.363 1.807-1.008 2.46A3.42 3.42 0 0112.562 16zm0-5.724a2.203 2.203 0 00-1.223.384 2.24 2.24 0 00-.81 1.002c-.18.412-.23.87-.143 1.312.082.428.288.823.59 1.134a2.197 2.197 0 002.419.486c.406-.169.752-.457.996-.826a2.263 2.263 0 00-.275-2.834 2.208 2.208 0 00-1.57-.658h.016z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M12.833 13.731l-1.406-1.46a.646.646 0 01.015-.878.597.597 0 01.847-.015l1.406 1.459a.646.646 0 01-.015.879.598.598 0 01-.847.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M12.289 13.731l1.406-1.46a.65.65 0 00.177-.446.65.65 0 00-.177-.447.603.603 0 00-.43-.187.587.587 0 00-.432.187l-1.406 1.459a.632.632 0 00-.18.447.65.65 0 00.18.447c.115.117.27.183.43.183a.603.603 0 00.432-.183z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__accountsfailed-multitone-outline__clip0_14553_7362"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

AccountsfailedMultitoneOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
AccountsfailedMultitoneOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = AccountsfailedMultitoneOutline;
exports["default"] = _default;